export const getPageLoadTime = (window: Window): number | undefined => {
  if (!window.performance) return

  const timing = (window.performance.timing ||
    window.performance.getEntriesByType('navigation')[0]) as
    | PerformanceTiming
    | PerformanceNavigationTiming

  return (timing.domComplete - timing.connectStart) / 1000 // saniye cinsinden
}
